import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import PaymentHistoryResourceModuleView from 'partial/OfferManager/modules/PaymentHistoryResourceModule/PaymentHistoryResourceModuleView';
import { useSelector } from 'react-redux';
const PaymentHistoryResourceModuleController = props => {
  const {
    additionalData,
    history,
    eventHandler,
    moduleHeading,
    pageName,
    moduleMetadata,
  } = props;
  const loading = props.globalLoadingFlag;

  const { paymentHistoryContainer, selectedFactor } = useSelector(state => ({
    paymentHistoryContainer:
      state?.paymentHistoryContainer?.paymentHistoryContainer,
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
  }));

  const paymentHistorySummaryAdditionalData =
    paymentHistoryContainer?.modules?.find(
      module => module.module === 'PAYMENT_HISTORY_SUMMARY',
    )?.additionalData;

  if (loading) {
    return <PageLoadingMask description={'Loading...'} />;
  } else {
    return (
      <PaymentHistoryResourceModuleView
        additionalData={additionalData}
        history={history}
        paymentHistorySummaryAdditionalData={
          paymentHistorySummaryAdditionalData
        }
        selectedFactor={selectedFactor}
        eventHandler={eventHandler}
        moduleHeading={moduleHeading}
        pageName={pageName}
        moduleMetadata={moduleMetadata}
      />
    );
  }
};

export default PaymentHistoryResourceModuleController;
